import PluginBase from './base';
import Logger from '../lib/logger';
import ScriptLoader from '../lib/script_loader';

export default class OptimeraMeasurement extends PluginBase {
  onSettingsLoaded() {
    Logger.log('Installing plugin: Optimera Measurement');
    this.setUpOptimeraMeasurement();
  }

  isEligible() {
    return (
      this.app.settings.optimera?.measurement?.enabled &&
      this.app.settings.optimera?.measurement?.scriptUrl &&
      this.app.settings.optimera?.measurement?.clientId
    );
  }

  setUpOptimeraMeasurement() {
    Logger.log('Setting up Optimera Measurement');
    if (!this.isEligible()) {
      Logger.log('Optimera Measurement not eligible, skipping setup', this.app.settings.optimera?.measurement);
      return;
    }

    this.loadOptimeraMeasurementScript();
  }

  async loadOptimeraMeasurementScript() {
    const dependency = {
      url:
        this.app.settings.optimera?.measurement?.scriptUrl +
        '?cid=' +
        this.app.settings.optimera?.measurement?.clientId,
      timeout: this.app.settings.optimera?.measurement?.scriptTimeout || 3000,
      customAttributes: {
        id: 'optimera-ops',
        'data-cid': this.app.settings.optimera?.measurement?.clientId,
      },
      parentElement: document.querySelector('footer'),
    };

    try {
      const url = await new ScriptLoader().load(dependency);

      Logger.log(`Optimera Measurement script ${url} has loaded successfully`);
    } catch (error) {
      Logger.error(
        `Error loading Optimera Measurement script from ${this.app.settings.optimera?.measurement?.scriptUrl}: ${error}`
      );
    }
  }
}
